var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Your account has been succesfully log out ")])
}
var staticRenderFns = []

export { render, staticRenderFns }